import * as constants from './constants';

const initialState = {
  allProductTypes: [],
  fetchingLoading: true,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
};

const productTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CREATE_PRODUCT_TYPES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.CREATE_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        allProductTypes: [...state.allProductTypes, action.data],
        isAdding: false,
      };
    case constants.CREATE_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    case constants.UPDATE_ORDER_PRODUCT_TYPES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.UPDATE_ORDER_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allProductTypes: action.data,
      };
    case constants.UPDATE_ORDER_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
      };

    case constants.FETCH_PRODUCT_TYPES:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_PRODUCT_TYPES_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        allProductTypes: action.data,
        isAdding: false,
      };
    case constants.FETCH_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_PRODUCT_TYPES:
      return {
        ...state,
        updateLoading: true,
      };
    case constants.UPDATE_PRODUCT_TYPES_SUCCESS:
      const updated = state.allProductTypes.map((el) =>
        el._id === action.data._id ? { ...el, ...action.data } : el
      );
      return {
        ...state,
        allProductTypes: updated,
        updateLoading: false,
        isAdding: false,
      };
    case constants.UPDATE_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_PRODUCT_TYPES:
      return {
        ...state,
        updateLoading: true,
        isAdding: false,
      };
    case constants.DELETE_PRODUCT_TYPES_SUCCESS:
      const updatedData = state.allProductTypes.filter(
        (el) => el._id !== action.data
      );
      return {
        ...state,
        allProductTypes: updatedData,
        updateLoading: false,
        isAdding: false,
      };
    case constants.DELETE_PRODUCT_TYPES_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };
    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };

    default:
      return state;
  }
};

export default productTypesReducer;
